import React from 'react';
import { Helmet } from 'react-helmet';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import TableCountDropdown from 'components/TableCountDropdown';
import RoleGate from 'components/RoleGate';
import { ADMIN, PAYROLL } from 'components/RoleGate/constants';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';

// Child Components
import PeopleTable from './components/PeopleTable';
// @ts-ignore
import PeoplePagination from './components/PeoplePagination';
import PersonCreateButton from './components/PersonCreateButton';
import PersonCreateModal from './components/PersonCreateModal';
import PersonDeleteModal from './components/PersonDeleteModal';
import PersonUpdateModal from './components/PersonUpdateModal';
import ExportPeopleButton from './components/ExportPeopleButton';
import ExportPeopleModal from './components/ExportPeopleModal';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const People = (): React.ReactElement => (
    <ErrorBoundary
        namespace="People"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>
                {'People - '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <PageTitleAndFilters
            title="People"
            searchInputPlaceholder="Search people"
            Button={
                <RoleGate requiredRoles={[ADMIN, PAYROLL]}>
                    <PersonCreateButton />
                </RoleGate>
            }
            SecondActionButton={<ExportPeopleButton />}
            group
            groupMultiple
            roles
            rolesMultiple
        />
        <PageWrapper top={0} bottom={50}>
            <PeopleTable />
            <div style={{ display: 'flex' }}>
                <div style={{ marginLeft: 'auto' }}>
                    <TableCountDropdown defaultCount={25} />
                    <PeoplePagination />
                </div>
            </div>
        </PageWrapper>
        <CurrentSeasonInProgressGate>
            <RoleGate requiredRoles={[ADMIN, PAYROLL]}>
                <React.Fragment>
                    <PersonCreateModal />
                    <PersonDeleteModal />
                    <PersonUpdateModal />
                    <ExportPeopleModal />
                </React.Fragment>
            </RoleGate>
        </CurrentSeasonInProgressGate>
    </ErrorBoundary>
);

export default People;
